import request from 'axios';

export const FETCH_SPECIALIZATIONS = 'crowdspring/profile/FETCH_SPECIALIZATIONS';
export const FETCH_SPECIALIZATIONS_REQUEST = 'crowdspring/profile/FETCH_SPECIALIZATIONS_REQUEST';
export const FETCH_SPECIALIZATIONS_FAILURE = 'crowdspring/profile/FETCH_SPECIALIZATIONS_FAILURE';
export const FETCH_SPECIALIZATIONS_SUCCESS = 'crowdspring/profile/FETCH_SPECIALIZATIONS_SUCCESS';

export function parseSpecializations(response) {
  const data = response.data.map(({ id, name }) => ({ label: name, value: id }));

  return {
    ...response,
    data
  };
}

export function fetchSpecializations() {
  const opts = {
    method: 'get',
    url: '/api/v1/specializations/',
  };
  return {
    type: FETCH_SPECIALIZATIONS,
    promise: request(opts).then(parseSpecializations),
  };
}

export function saveSpecializations(user, specializationList) {
  /* only creatives have specializations */
  if (!user.is_creative) {
    return Promise.resolve()
  }

  const specializations = specializationList.filter(value => (value && value.trim()));
  const opts = {
    method: 'put',
    url: `/api/v1/users/${user.id}/specializations/`,
    data: { specializations }
  };
  return request(opts);
}

const INITIAL_STATE = {
  data: [],
  isLoading: false,
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_SPECIALIZATIONS:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_SPECIALIZATIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./profile/ducks/specializations.js